// extracted by mini-css-extract-plugin
module.exports = {"section":"CanMove_section__HHy4T"};